import { render } from "./Evaluation.vue?vue&type=template&id=3b67f5b3&scoped=true&ts=true"
import script from "./Evaluation.vue?vue&type=script&lang=ts"
export * from "./Evaluation.vue?vue&type=script&lang=ts"

import "./Evaluation.vue?vue&type=style&index=0&id=3b67f5b3&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b67f5b3"]])

export default __exports__